export const URLENUM = {
	'/otherStoreIndex/storeOtherStore': '/', // 第三方站点首页（由 mateUrl 拼 companyId/home）
	'/specialArea': '/specialDetail', // 专区二级页面
	'/storeSpecialArea': '/specialDetail', // 专区二级页面
	'/notice': '/gyInfo/list?type=1', // 国药咨询
	'/noticeDetails': '/gyInfo/detail?companyId=1', // 国药咨询二级页面
	'/infoList': '/gyInfo/list', // 咨询管理一级页面
	'/infoDetail': '/gyInfo/detail', // 咨询管理二级页面
	'/goodsDetails': '/goodDetail', // 占位：实际跳转由 mateUrl 特判为 /[companyId]/products/[productId].html
	'/otherStoreIndex/storeGoodsDetails': '/goodDetail', // 同上
};
